import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import uniqid from 'uniqid';

var _excluded = ["style", "className"];
var PX_REM_RATIO = 0.0625;
var safeRest = function safeRest(_ref) {
  _ref.style;
      _ref.className;
      var props = _objectWithoutProperties(_ref, _excluded);

  return props;
};
var getExternalLink = function getExternalLink(isExternal) {
  return isExternal ? '_blank' : '_top';
};
var deprecate = function deprecate(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  } // eslint-disable-next-line


  console.warn("[Deprecate] ".concat(componentName, ": ").concat(message)); //NOSONAR
};
var warn = function warn(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  } // eslint-disable-next-line


  console.warn("".concat(componentName, ": ").concat(message)); //NOSONAR
};
/**
 * Compares two string values to see if they match, irrespective of case
 * @param {string} a
 * @param {string} b
 */

var matches = function matches() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return a.toUpperCase() === b.toUpperCase();
};
/**
 * A no-operation identity function that returns its inputs
 * @param  {...any} rest
 */

var noop = function noop() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }

  return [].concat(rest);
};
/**
 * Good enough unique ID generator that returns a unique ID for
 * a single machine and single process.
 * @param {string} prefix - prefix to append to generated id
 */

var uniqueId = function uniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return uniqid.time(prefix);
};
/**
 * Replaces spaces in a string with underscores and trims any whitespace
 * @param {string} str - string value to remove spaces from
 */

var sanitizeSpaces = function sanitizeSpaces(str) {
  return str.trim().replace(/ /g, '_');
};
/**
 * Iterate over an errors object and look for any where isError = true
 * @param {array} errors - array of error objects { msg(string), id(string), isError(bool) }
 */

var hasErrors = function hasErrors(errors) {
  return errors.reduce(function (accum, e) {
    return accum || e.isError;
  }, false);
};
/**
 * Handles an onBlur event on an input to only call onBlur when focus leaves the entire group
 * Focus moving between items in groupedRefs will NOT call onBlur
 */

var handleGroupedInputsBlur = function handleGroupedInputsBlur(event, onBlur, groupedRefs) {
  var nextFocusedElement = event === null || event === void 0 ? void 0 : event.relatedTarget;
  var isLeavingGroup = !nextFocusedElement || !groupedRefs.map(function (ref) {
    return ref === null || ref === void 0 ? void 0 : ref.current;
  }).filter(function (current) {
    return current !== undefined;
  }).includes(nextFocusedElement);

  if (isLeavingGroup) {
    onBlur();
  }
};
/**
 * Convert a px value to a rem value according to the ratio provided by CDS
 * Returns the converted value as a string with 'rem' appended
 * @param {number} px - px value to be converted; it must be a number
 */

var rem = function rem(px) {
  return "".concat(px * PX_REM_RATIO, "rem");
};

export { deprecate, getExternalLink, handleGroupedInputsBlur, hasErrors, matches, noop, rem, safeRest, sanitizeSpaces, uniqueId, warn };
